import FlashLib from "flashlib";
import Animation from "Engine/base/animation/Animation";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class BackgroundContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.animation = null;


        this.init();
        this.changeState(1);
    }

    init() {
        this.animation = new Animation('background_spine');
    }

    changeState(value) {
        this.goToFrame(value);
        if (value === 1) {
            this.animation.play(true, 'idle');
            this.addChild(this.animation);
        }
    }
}